import type { LocaleMessageSchema } from '../types';

export default {
  Common: {
    loading: 'Laden...',
  },
  errors: {
    session_create_error:
      'Sitzung konnte nicht erstellt werden.\nBitte versuchen Sie es erneut.',
    session_continue_error:
      "Ihre Sitzung konnte nicht geladen werden. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie den Support unter service{'@'}theartisan.ai.",
    kiosk_not_found:
      'Kiosk konnte nicht geladen werden.\nBitte versuchen Sie es erneut.',

    art_style_missing: 'Diesem Kiosk wurden keine Kunststile hinzugefügt',
    art_style_fetch_error: 'Kunststil konnte nicht geladen werden',
    art_style_preload_error:
      'Vorschau des Kunststils konnte nicht geladen werden',

    face_detection_server_error:
      'Foto konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.',
    face_detection_preload_error:
      'Fehler beim Vorladen der erkannten Gesichter',
    face_detection_no_faces:
      'Keine Gesichter erkannt. Bitte versuchen Sie, ein anderes Foto aufzunehmen.',

    photo_webcam_not_allowed: 'Webcam-Zugriff verweigert',
    photo_webcam_not_found:
      'Webcam nicht gefunden. Bitte prüfen Sie, ob sie mit dem Kiosk verbunden ist.',
    photo_webcam_hardware_error:
      'Webcam ist beschäftigt oder funktioniert nicht.\nBitte versuchen Sie es erneut oder bitten Sie um Hilfe.',
    photo_webcam_photo_failed:
      'Foto mit der Webcam konnte nicht aufgenommen werden',

    photo_phone_missing_session_id:
      'Wir konnten Ihre Sitzung nicht finden.\nBitte scannen Sie den QR-Code erneut.',
    photo_phone_missing_kiosk_slug:
      "Kiosk in Ihrer Sitzung nicht gefunden. Wenn das Problem weiterhin besteht, kontaktieren Sie den Support unter service{'@'}theartisan.ai.",
    photo_phone_limit_exceeded: 'Zu viele Fotos ausgewählt',
    photo_phone_qr_error:
      'QR-Code für den Foto-Upload konnte nicht erstellt werden',

    photo_file_unsupported_type: 'Nicht unterstützter Dateityp',
    photo_file_cannot_process:
      'Dieses Foto kann nicht verarbeitet werden.\nBitte versuchen Sie ein anderes.',
    photo_file_cannot_process_heic:
      'HEIC-Foto kann nicht verarbeitet werden.\nBitte versuchen Sie ein anderes.',

    portrait_generation_error:
      'Beim Erstellen Ihres Porträts ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    portrait_generation_faces_not_selected:
      'Keine Gesichter für die Porträterstellung ausgewählt',
    portrait_generation_style_not_selected:
      'Kein Kunststil für die Porträterstellung ausgewählt',
    portrait_generation_over_limit: 'Zu viele Generierungsversuche',

    portraits_download_session_error:
      "Wir konnten Ihre Sitzung nicht finden. Bitte überprüfen Sie den eingegebenen Code. Wenn das Problem weiterhin besteht, kontaktieren Sie den Support unter service{'@'}theartisan.ai.",
    portraits_download_kiosk_error:
      "Kiosk in Ihrer Sitzung nicht gefunden. Wenn das Problem weiterhin besteht, kontaktieren Sie den Support unter service{'@'}theartisan.ai.",
    portraits_download_portraits_error:
      "Keine Porträts in Ihrer Sitzung gefunden. Wenn das Problem weiterhin besteht, kontaktieren Sie den Support unter service{'@'}theartisan.ai.",

    payment_partner_mode_missing_stripe_account:
      'Der Partner-Zahlungsmodus erfordert ein Stripe Connect-Konto. Bitte konfigurieren Sie das Partner-Stripe-Konto oder wechseln Sie zum Plattform-Zahlungsmodus.',

    api_error_missing_session_id: 'Sitzung nicht gefunden',
    api_error_email_code_validation:
      'Zahlungscode konnte nicht validiert werden. Bitte versuchen Sie es erneut.',
  },

  /**
   * Global components
   */

  OverlayError: {
    buttons: {
      close: 'Schließen',
      restart: 'Neu starten',
      retry: 'Erneut versuchen',
    },
  },
  Logo: {
    startOver: 'Neu starten',
  },
  Copyright: {
    copyright: 'powered by TheArtisan.ai',
    distribution: 'vertrieben von',
    terms:
      'Indem Sie auf diesem Gerät ein Foto aufnehmen, akzeptieren Sie unsere Richtlinien und Bedingungen. Um sie zu überprüfen, bitte',
    termsLink: 'hier klicken',
  },
  IdlePopup: {
    title: 'Sind Sie noch da?',
    caption: 'Ihre Sitzung endet, wenn Sie inaktiv sind.',
    buttonContinue: 'Ja, ich bin noch da',
    buttonRestart: 'Nein, neu starten',
  },
  GDPRConsent: {
    title: 'Zustimmung erforderlich',
    consentText:
      'Wir benötigen Ihre Zustimmung zur Verarbeitung Ihrer Gesichtsmerkmale (biometrische Daten), um künstlerische Transformationen zu erstellen. Sie dürfen nur fortfahren, wenn Sie 16 Jahre oder älter sind (oder die elterliche Zustimmung haben).',
    buttonConsent: 'Ich stimme zu',
    buttonDecline: 'Ich lehne ab',
    privacyPolicyLink: 'Datenschutzrichtlinie ansehen',
    declineMessage: 'Sie können ohne Zustimmung nicht fortfahren',
  },
  StepProgressIndicator: {
    photoShort: 'Foto',
    photoLong: 'Foto aufnehmen',
    facesShort: 'Gesichter',
    facesLong: 'Gesichter auswählen',
    groupPortraitsShort: 'Gruppe',
    groupPortraitsLong: 'Gruppenporträts',
    portraitsShort: 'Porträts',
    portraitsLong: 'Porträts auswählen',
    printShort: 'Drucken',
    printLong: 'Bezahlen & Drucken',
    sendToPickupShort: 'Abholung',
    sendToPickupLong: 'Zur Abholstation',
  },
  UploadedPhotosSidebar: {
    title: 'Ihre Fotos',
    count: '+{extraPhotoCount} mehr',
  },
  NumericKeyboard: {
    invalidPin: 'Ungültiger PIN-Code',
    clear: 'Löschen',
    enter: 'Eingeben',
  },
  OutOfService: {
    message:
      'Ihr Vertrag scheint pausiert oder abgelaufen zu sein.\nBitte kontaktieren Sie Ihren Händler für Unterstützung.',
  },

  /**
   * Steps
   */

  Home: {
    title: 'Erstellen Sie Ihr Porträt in Sekunden!',
    button: 'Jetzt ausprobieren!',
  },
  ArtStyle: {
    title: 'Wählen Sie Ihren Stil',
  },
  PhotoFromWebcam: {
    titleGetReady: 'Bereit zum Fotografieren',
    titleAttention: 'In die Kamera schauen!',
    titleReview: 'Gefällt Ihnen dieses Foto?',
    titleUpload: 'Foto wird hochgeladen…',
    buttonPrimaryPhoto: 'Foto aufnehmen',
    buttonPrimaryUse: 'Ja, dieses Foto verwenden',
    buttonPrimaryRetake: 'Foto erneut aufnehmen',
    buttonSecondaryUpload: 'Vom Telefon hochladen',
    buttonSecondaryRetake: 'Nein, erneut aufnehmen (1 Versuch übrig)',
    buttonSecondaryUseFirst: 'Nein, das erste Foto verwenden',
    titleCameraError: 'Kamera nicht verfügbar',
    buttonRetryCamera: 'Kamera erneut versuchen',
  },
  PhotoPromptFromPhone: {
    title: 'Fotos vom Telefon hochladen?',
    caption:
      'Überraschen Sie Freunde und Familie —\nLaden Sie ihre Fotos hoch, um Porträts zu erstellen.',
    buttonUpload: 'Ja, vom Telefon hochladen',
    buttonSkip: 'Nein, Telefon-Upload überspringen',
  },
  PhotoFromPhone: {
    title: 'Fotos von Ihrem Telefon hochladen',
    step1: 'QR-Code mit dem Telefon scannen',
    step2: 'Fotos auswählen',
    step3: 'Auf den Upload warten',
    waiting: 'Warten auf Ihren Upload…',
    done: 'Upload erfolgreich',
    buttonCancel: 'Abbrechen & Zurück',
    buttonSkip: 'Telefon-Upload überspringen',
    buttonContinue: 'Weiter',
    gdprConsentAll:
      'Ich habe die Zustimmung aller Personen auf diesem Foto zur Verarbeitung ihrer Gesichtsmerkmale',
    gdprOver16: 'Niemand auf diesem Foto ist unter 16 Jahre alt',
    gdprResponsibility:
      'Ich übernehme die volle Verantwortung für die DSGVO-Konformität',
    gdprAgreeToPrefix: 'Ich stimme den',
    gdprPrivacyPolicyLink: 'Datenschutzbestimmungen',
    gdprAgreeToSuffix: 'für hochgeladene Fotos zu',
    gdprCheckboxesRequired:
      'Bitte aktivieren Sie alle Kästchen unten, um fortzufahren',
    buttonSkipKioskPhoto: 'Kiosk-Foto überspringen',
    buttonTakeWebcamPhoto: 'Foto mit Webcam aufnehmen',
  },
  FacesIndividual: {
    title: 'Für wen möchten Sie einzelne Porträts erstellen?',
    buttonConfirm: 'Bestätigen & Weiter',
    genderMale: 'Männlich',
    genderFemale: 'Weiblich',
    genderNonBinary: 'Nicht-binär',
    age0to2: '0-2',
    age3to9: '3-9',
    age10to19: '10-19',
    age20to29: '20-29',
    age30to39: '30-39',
    age40to49: '40-49',
    age50to59: '50-59',
    age60to69: '60-69',
    age70plus: '70+',
    raceWhite: 'Weiß',
    raceBlack: 'Schwarz',
    raceEastAsian: 'Ostasiatisch',
    raceSoutheastAsian: 'Südostasiatisch',
    raceIndian: 'Indisch',
    raceLatino: 'Latino',
    raceMena: 'Nahöstlich',
  },
  Portraits: {
    title: 'Wählen Sie Ihre Porträts!',
    buttonNext: 'Weiter: Ausgewählte drucken',
    buttonNextGroupOnly: 'Nur mit Gruppenporträts fortfahren',
    galleryScrollBack: 'Vorherige Porträts',
    galleryScrollForward: 'Nächste Porträts',
    filterLabel: 'Anzeigen',
    filterAll: 'Alle',
    filterGroup: 'Gemeinsam',
    filterIndividual: 'Einzeln',
    stageKindGroup: 'Gruppenporträt',
    stageKindIndividual: 'Porträt',
    stagePosition: '{index} von {count}',
    stageSelect: 'Auswählen',
    stageSelected: 'Ausgewählt ✓',
    buttonMore: 'Mehr Porträts erstellen ({count} übrig)',
    popupTitle: 'Möchten Sie Ihre Bestellung abschließen?',
    popupGroupSelected: 'Gruppenporträts ausgewählt: {count} ({price})',
    popupIndividualSelected: 'Einzelporträts ausgewählt: {count} ({price})',
    popupTotalSum: 'Gesamtsumme: {sum}',
    popupButtonNo: 'Nein, zurück',
    popupButtonYes: 'Ja, drucken & bezahlen!',
    error: 'Ups! Dieses Porträt konnte nicht generiert werden.',
    placeholderGenerating: 'Porträt wird generiert…',
    placeholderLoading: 'Porträt wird geladen…',
    groupPlaceholder: 'Hier erscheint Ihr Gruppenporträt',
    buttonRetry: 'Erneut versuchen',
    buttonErrorDetails: 'Fehlerdetails',
    retrying: 'Wird wiederholt...',
    maxRetriesReached: 'Max. Versuche erreicht',
    retryAttempts: 'Wiederholungsversuche: {count}',
    printingLockedPopupTitle:
      'Bitte rufen Sie den n\u00e4chsten Mitarbeiter, um Ihre Portr\u00e4ts zu drucken.',
    generationPendingTitle: 'Einige Porträts werden noch erstellt',
    generationPendingCaption:
      '{count} Porträts werden noch erstellt. Möchten Sie warten, um alle zu sehen?',
    generationPendingWait: 'Auf alle warten',
    generationPendingSendReady: '{count} fertige Porträts senden',
    printingLockedPopupCaption:
      'Das Drucken am Kiosk ist nicht verf\u00fcgbar, solange kein Mitarbeiter anwesend ist.',
  },
  PortraitsGroup: {
    buttonMore: 'Mehr Porträts erstellen',
  },
  PrintLock: {
    lockTitle: 'Drucken sperren',
    unlockTitle: 'Drucken freigeben',
  },
  PaymentType: {
    title: 'Wie möchten Sie bezahlen?',
    optionCardTitle: 'Kreditkarte',
    optionCardCaption: 'Visa, Mastercard, & 10+ unterstützte Karten',
    optionVoucherTitle: 'Vorausbezahlte Porträts',
    optionVoucherCaption: 'Im Ticket enthalten — Mitarbeiter druckt',
  },
  PaymentTerminal: {
    title: 'Bitte folgen Sie den Anweisungen auf dem Zahlungsterminal',
    titlePaymentSuccess: 'Ihre Porträts werden gedruckt…',
    titlePaymentError: 'Zahlung fehlgeschlagen',
    titlePrintError1: 'Einige Porträts konnten leider nicht gedruckt werden.',
    titlePrintError2:
      'Bitte drücken Sie "Erneut drucken" unten, um es erneut zu versuchen.',
    buttonRetryPrinting: 'Erneut drucken',
    buttonRetry: 'Erneut versuchen',
    buttonCancel: 'Abbrechen',
    buttonExitSession: 'Neu starten',
    buttonBack: 'Zurück',
    total: 'Gesamt:',
    captionPayment: 'Warten auf Ihre Zahlung…',
    captionPrinting: 'Drucken erfolgreich',
    captionPaymentError:
      'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder starten Sie neu.',
    captionPaymentFinal:
      'Die Zahlung hat nicht funktioniert. Bitte wenden Sie sich an das Personal.',
    failureCaptions: {
      notEnoughFunds:
        'Die Karte hat keine ausreichende Deckung. Bitte versuchen Sie eine andere Karte.',
      expiredCard:
        'Diese Karte ist abgelaufen. Bitte versuchen Sie eine andere Karte.',
      cardDeclined:
        'Die Karte wurde abgelehnt. Bitte versuchen Sie eine andere Karte.',
      cardError:
        'Diese Karte kann hier nicht verwendet werden. Bitte versuchen Sie eine andere Karte.',
      processingError:
        'Die Zahlung wurde nicht abgeschlossen. Bitte versuchen Sie es mit derselben Karte erneut.',
      readerError:
        'Das Kartenlesegerät ist nicht verfügbar. Bitte wenden Sie sich an das Personal.',
      timeout:
        'Die Zahlung hat zu lange gedauert. Bitte versuchen Sie es erneut.',
    },
    errorMessage: 'Leider konnten wir Ihre Zahlung nicht verarbeiten',
    popupCancelledTitle: 'Zahlung abgebrochen',
    popupCancelledCaption: 'Möchten Sie es erneut versuchen oder neu starten?',
    popupButtonContinue: 'Erneut versuchen',
  },
  PaymentVoucher: {
    title:
      'Bitte rufen Sie einen Mitarbeiter für Hilfe bei der Zahlung mit einem Gutschein an',
    buttonBack: 'Zurück',
    pinTitle: 'Mit Gutschein bezahlen',
  },
  Printing: {
    title: 'Ihre Porträts werden gedruckt…',
    titleError: 'Einige Porträts konnten leider nicht gedruckt werden',
    buttonPrintAgain: 'Erneut drucken',
    buttonContinueWithoutPrint: 'Ohne Drucken fortfahren',
    error: 'Ups! Dieses Porträt konnte nicht gedruckt werden.',
    errorPartial: '{printed} von {total} gedruckt',
    retrying: 'Neuer Versuch…',
    waiting: 'Warten auf den Drucker…',
  },
  PrintFailed: {
    title: 'Leider konnten wir Ihre Fotos nicht drucken',
    titlePartial: '{printed} von {total} Fotos gedruckt',
    caption:
      'Sie können eine neue Sitzung starten und neue Porträts erstellen.',
    captionRefunded: 'Wir haben {amount} auf Ihre Karte zurückerstattet.',
    captionNotCharged: 'Wir haben Ihnen {amount} nicht berechnet.',
    captionRefundHelp: 'Ein Mitarbeiter hilft Ihnen bei der Erstattung.',
  },
  Success: {
    title: 'Vielen Dank!',
    caption:
      'Ihre Bilder wurden gedruckt. Bitte holen Sie sie an der Rezeption ab.',
    buttonStartAgain: 'Neu beginnen',
  },
  GoPhotoScan: {
    title: 'PhotoPass scannen',
    subtitle: 'Halten Sie Ihren PhotoPass QR-Code vor den Scanner',
    invalidCode: 'Ungültiges Codeformat. Bitte erneut scannen.',
    failedToRegister:
      'Code konnte nicht registriert werden. Bitte versuchen Sie es erneut.',
    error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
  },

  /**
   * Customer-facing components
   */

  CustomerPhotoFromPhone: {
    title: 'Fotos aus Ihrer Galerie hochladen',
    buttonSelect: 'Fotos auswählen',
    maxCount: 'Maximal {count} Fotos',
    uploading: 'Wird hochgeladen…',
    uploadError:
      'Upload fehlgeschlagen. Bitte \u00fcberpr\u00fcfen Sie Ihre Verbindung und versuchen Sie es erneut.',
    buttonRetry: 'Erneut versuchen',
    successTitle: 'Upload erfolgreich',
    successCaption:
      'Bitte kehren Sie zum Kiosk zurück und folgen Sie den Anweisungen auf dem Bildschirm.',
  },
  CustomerPortraitsDownload: {
    title: 'Code eingeben, um Ihr Porträt zu erhalten',
    buttonSubmit: 'Absenden',
    error:
      'Dieser Code scheint nicht zu stimmen. Überprüfen Sie den 8-stelligen Code auf Ihrem Foto und versuchen Sie es erneut.',
    errors: {
      wrongFormat:
        'Dieser Code scheint nicht zu stimmen. Überprüfen Sie den 8-stelligen Code auf Ihrem Foto und versuchen Sie es erneut.',
      notFound:
        'Entschuldigung, keine Porträts gefunden. Bitte überprüfen Sie den Code — er ist auf der Vorderseite des Porträts unten links aufgedruckt.',
      serverError:
        'Entschuldigung, wir konnten Ihre Porträts momentan nicht abrufen. Bitte versuchen Sie es später erneut.',
    },
  },
  CustomerSessionPass: {
    tabs: {
      photos: 'Fotos',
      pass: 'QR-Pass',
    },
    eyebrow: 'Dein Sitzungspass',
    title: 'Diese Seite geöffnet lassen',
    description:
      'Scanne an der Verkaufsstation den quadratischen Code unten. Deine Porträts findest du im Tab „Fotos“.',
    descriptionNothingPrinted:
      'Scannen Sie an der Verkaufsstation den quadratischen Code unten, um Ihre Fotos auszuwählen und zu drucken.',
    scanLabel: 'An der Verkaufsstation scannen',
    codeLabel: 'Sitzungscode',
    ready: 'Bereit zum Scannen',
    loading: 'Code wird vorbereitet',
    unavailable: 'Code nicht verfügbar',
    qrAlt: 'QR-Code für die Verkaufsstation',
    defaultVenue: 'TheArtisan.ai Porträterlebnis',
  },
  CustomerPortraitsDownloadCode: {
    error: 'Ups! Dieses Porträt konnte nicht geladen werden.',
    placeholder: 'Ihr Porträt wird geladen…',
    imageAlt: 'Porträt',
    buttonDownload: 'Herunterladen',
    buttonSendOrShare: 'Senden oder Teilen',
    buttonRetry: 'Erneut versuchen',
    shareTitle: 'Ihr Porträt von {clientName}',
    shareText: 'Von TheArtisan.ai',
    states: {
      processing:
        'Ihre Porträts werden noch vorbereitet. Versuchen Sie es gleich noch einmal.',
      partial:
        'Einige Porträts oder Seitendetails konnten nicht geladen werden. Verfügbare Downloads funktionieren weiterhin.',
    },
    actions: {
      enterAnotherCode: 'Anderen Code eingeben',
      contactSupport: 'Support kontaktieren',
      retryDownload: 'Download erneut versuchen',
      downloadFailed:
        'Download fehlgeschlagen. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
      linkCopied: 'Link kopiert. Sie können ihn in eine Nachricht einfügen.',
      shareFailed:
        'Teilen ist momentan nicht verfügbar. Bitte versuchen Sie es erneut.',
    },
  },
  CustomerDigitalExtras: {
    downloadTitle: 'Deine Fotos und Extras',
    downloadIntro:
      'Speichere Fotos, lade Extras herunter oder öffne dein QR-Ticket.',
    photosTitle: 'Deine Fotos',
    photosIntro: 'Speichere deine Fotos oder öffne deinen QR-Pass.',
    navigation: 'Deine Downloads',
    tabs: {
      photos: 'Fotos',
      extras: 'Video',
      pass: 'QR-Ticket',
    },
    title: 'Deine digitalen Extras',
    loading: 'Deine digitalen Extras werden geladen…',
    loadError: 'Dateien konnten nicht geladen werden. Prüfe deine Verbindung.',
    included: 'Enthalten',
    includedOrder:
      'Dein Video ist enthalten. Bewahre dein QR-Ticket auf, um es später zu öffnen.',
    preparingHelp:
      'Speichere diesen Link oder bewahre dein QR-Ticket auf. Du kannst diese Seite schließen und später zurückkehren.',
    reference: 'Referenz: {reference}',
    retry: 'Erneut versuchen',
    empty: 'Für diesen Besuch wurden keine digitalen Extras hinzugefügt.',
    orderTitle: 'Videobestellung',
    showCashier: 'Zeigen Sie diese Bestellung und Ihr QR-Ticket an der Kasse.',
    videoTotal: 'Gesamtbetrag Video',
    payAtDesk: 'Zahlung an der Kasse.',
    preparing: 'Deine Dateien werden vorbereitet…',
    failed:
      'Dein Video konnte nicht erstellt werden. Zeige die Referenz unten dem Team vor Ort, um Hilfe zu erhalten.',
    ready: 'Bereit zum Herunterladen',
    video: 'Bewegtes Foto',
    videoDescription:
      'Dein Lieblingsmoment in Bewegung. Für deine Storys und den Familienchat.',
    download: 'Herunterladen',
    share: 'Datei teilen',
    preparingShare: 'Datei wird geladen…',
    shareFailed: 'Teilen ist nicht verfügbar. Bitte lade die Datei herunter.',
  },
  GoPhotoUpload: {
    waitingForPortraits: 'Ihre Porträts werden fertiggestellt',
    waitingForPortraitsSubtitle:
      'Bitte warten Sie, während die übrigen Porträts erstellt werden.',
    success: 'Fotos hochgeladen!',
    successSubtitle: 'Deine Fotos sind jetzt auf deinem PhotoPass verfügbar.',
  },
  system: {
    reconnecting: 'Verbindung wird wiederhergestellt…',
  },
} satisfies LocaleMessageSchema;
